import { Flex } from '@chakra-ui/react';
import { Modal, ModalBody, ModalHeader } from 'components/UI';
import { IBom } from 'types';
import { useFlc, useToast } from 'hooks';
import BomForm, { BomFormValues } from 'components/common/Popup/BomForm';
import ButtonProc from 'components/common/Buttons/ButtonProc';
import { checkIfError } from 'utils/helpers';
import { gradientStyle, specialFont } from 'constants/theme';

type ErpModalProps = {
  flc?: string;
  flcUrl?: string;
  closePopup: () => void;
  bom?: IBom[];
  isOpen: boolean;
};

const buttonStyles = {
  ...gradientStyle,
  _focus: {
    boxShadow: 'none',
  },
  color: 'primaryFontColour.400',
  borderStyle: 'solid',
};

const ErpModal = ({ closePopup, flc, flcUrl, bom, isOpen }: ErpModalProps) => {
  const [flcPost] = useFlc();

  const [showToast] = useToast();

  const handleSubmit = async (values: BomFormValues) => {
    const response = await flcPost({
      projectNumber: values.projectNumber,
      quantity: values.quantity,
      variantTenant: window.location.origin,
      flcUrl,
      bom: bom!,
    });

    const isError = checkIfError(response);

    closePopup();
    showToast({
      status: isError ? 'error' : 'success',
      message: isError ? response.data?.message ?? 'Data submission failed.' : 'Data has been submitted successfully.',
    });
  };
  const renderFlcIntegration =
    flc === 'true' ? (
      <BomForm onSubmit={handleSubmit} buttonProps={{ sx: buttonStyles }} />
    ) : (
      <>
        <Flex
          sx={{
            fontStyle: 'italic',
            justifyContent: 'center',
            fontFamily: specialFont,
            fontSize: 14,
          }}
        >
          Integration is inactive.
        </Flex>
        <Flex justifyContent="space-around">
          <ButtonProc
            first="CLOSE"
            onClick={closePopup}
            sx={{
              w: '85%',
              mt: 8,
              ...buttonStyles,
            }}
            size="sm"
          />
        </Flex>
      </>
    );

  return (
    <Modal
      isOpen={isOpen}
      isCloseButton
      closeOnEsc={false}
      closeOnOverlayClick
      isCentered
      size="sm"
      onClose={closePopup}
    >
      <ModalHeader textAlign="center" fontSize="4xl">
        SEND BOM TO PLM
      </ModalHeader>
      <ModalBody pb={8}>{renderFlcIntegration}</ModalBody>
    </Modal>
  );
};

export default ErpModal;
